export namespace FalconMembership {
  export interface UserPasswordResetForm {
    Email: string;

    ResetToken: string;

    NewPassword: string;
  }

  export interface UserSignInForm {
    UserName: string;
    Password: string;
    RememberMe: boolean;
    BookingToken: string;
  }

  export interface UserChangeEmailForm {
    Email: string;

    Token: string;
  }
  export interface UserChangePasswordForm {
    OldPassword: string;

    NewPassword: string;
  }

  export enum PasswordResetResultType {
    Success = 1,
    Failed = 2,
    UserNotFound = 3,
    TokenNotCorrectOrExpired = 4,
  }

  export interface PasswordResetResult {
    ResultType: PasswordResetResultType;
    Message: string;
  }

  export enum SignInStatus {
    /**Sign in was successful */
    Success,

    /**User is locked out */
    LockedOut,

    /**Sign in requires addition verification (i.e. two factor) */
    RequiresVerification,

    /**Sign in failed (username/password not correct) */
    Failure,

    /**Internal error */
    Exception,
  }

  export interface UserRegisterPayload {
    UserName: string;

    Email: string;

    Password: string;

    EmailToken: string;

    BookingToken: string;
  }

  export interface UserProfileModel {
    UserID: string;
    UserName: string;
    Email: string;
    EmailConfirmed: boolean;
    Status: number;
  }
  export enum EmailChangeResultType {
    Success = 1,
    Failed = 2,
    UserNotFound = 3,
    TokenNotCorrectOrExpired = 4,
  }

  export enum PasswordChangeResultType {
    Success = 1,
    Failed = 2,
    UserNotFound = 3,
    OldPasswordNotMatch = 4,
  }
  export enum UserStatusTypeEnum {
    /**新创建用户状态 */
    Init = 0,
    Active = 1,
    Locked = 2,
  }
  export interface UserBookingBindingPayload {
    // UserID: string;
    BookingNumber: string;
    // SiteDomainName: string;
    //     BindingOptions: UserBookingBindingOptions;
    // }
    // export interface UserBookingBindingOptions {
    //     /**是否忽略联系信息一致性 */
    //     IgnoreValidateContactInfo: boolean;
    //     /**是否允许变更绑定目标 */
    //     AllowBindingOverwrite: boolean;
  }

  export enum FalconIdentifierType {
    /**邮箱 */
    EMAIL = 'email',
    /**手机 */
    PHONE = 'phone',
    /**用户名 */
    USERNAME = 'uname',
  }

  export enum FalconSignInType {
    PASSWORD = 'pwd',
    VERIFICATION_CODE = 'code',
    LINK = 'link',
  }

  export interface GetSignInTypePayload {
    IdentifierType: FalconIdentifierType;
    Identifier: string;
    SessionToken?: string;
    AppID?: string;
  }

  export enum SignInTypeGetStatus {
    /// <summary>
    /// The operation was successful
    /// </summary>
    Success,
    /// <summary>
    /// The identifier is locked out (e.g. too many failed attempts)
    /// </summary>
    IdentityLockedOut,
    /// <summary>
    /// The identifier type is not supported
    /// </summary>
    NotSupportedType,
    /// <summary>
    /// System failure
    /// </summary>
    Failure = 99,
  }
  export interface FalconSignInTypeInfo {
    SignInType: FalconSignInType;
    IsRegistered: boolean;
    IsNeedGenerateMaterial: boolean;
  }
  export interface GetSignInTypeResponse {
    Status: SignInTypeGetStatus;
    Message: string;
    Info: FalconSignInTypeInfo;
    SessionToken: string;
    SessionExpireAt: number;
  }

  export interface SignInVerificationPayload {
    IdentifierType: FalconIdentifierType;
    Identifier: string;
    Password: string;
    SessionToken: string;
    RememberMe: boolean;
    TermsAndConditionsAgreed: boolean;
  }

  export enum MaterialSignInErrorCode {
    InvalidOperation,
    MaterialContent_Expired,
    MaterialContent_Invalid,
    IdentityLockedOut,
    Failure = 99,
  }
  export interface SignInVerificationResult {
    Success: boolean;
    ErrorCode?: MaterialSignInErrorCode;
    Message: string;
    UserID: string;
  }

  export interface SendSignInVerificationCodePayload {
    Identifier: string;
    SessionToken: string;
  }

  export enum VerificationCodeSendErrorCode {
    /**
     * invalid operation
     */
    InvalidOperation,
    /**
     * invalid session token
     */
    InvalidSessionToken,
  }
  export interface SendSignInVerificationCodeResult {
    Success: boolean;
    ErrorCode?: MaterialSignInErrorCode;
    ResendAfterSeconds: string;
  }
}
